import { CalendarDaysIcon, CompassIcon, MapPinnedIcon } from 'lucide-react';
import type { Exhibition } from '~/api/types';
import { Dayjs } from '~/lib/dayjs';
import type { SupportedLanguage } from '~/lib/i18n';

interface Params {
  exhibition: Exhibition;
  lang: SupportedLanguage;
}

export default function ExhibitionDetails({
  exhibition,
  lang,
  ...props
}: React.ComponentProps<'div'> & Params) {
  const { start, end, place } = exhibition;
  // console.log(place);
  if (!place) {
    // console.warn(`Faltando informações sobre o local.`);
    return null;
  }
  const localizedPlace = place[lang];
  // console.log(localizedPlace);
  if (!localizedPlace) {
    // console.warn(`Faltando informações localizadas.`);
    return null;
  }
  return (
    <div {...props}>
      <div className="flex items-center gap-2 mt-1">
        <MapPinnedIcon size={16} />
        <p className="text-sm">{localizedPlace.city}</p>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <CompassIcon size={16} />
        <p className="text-sm">{localizedPlace.name}</p>
      </div>
      {/* TODO: i18n */}
      <div className="flex items-center gap-2 mt-1">
        <CalendarDaysIcon size={16} />
        <div className="text-sm">{`${Dayjs(start).format('DD/MM/YYYY')} - ${Dayjs(end).format(
          'DD/MM/YYYY'
        )}`}</div>
      </div>
    </div>
  );
}
